import baseAPIHelper from "./baseAPIHelper";

function getList(token, carpark, successCallback, failCallback) {
  let url = `${process.env.REACT_APP_API_DOMAIN}/api/announcement`;
  const urlObj = new URL(url);
  if (token) {
    urlObj.searchParams.set("access_token", token);
  }
  if (carpark) {
    urlObj.searchParams.set("carpark", carpark);
  }
  if (token || carpark) {
    url = urlObj.toString();
  }
  baseAPIHelper("GET", url, null, successCallback, failCallback);
}

const announcementAPIHelper = {
  getList,
};

export default announcementAPIHelper;
